import { render, staticRenderFns } from "./VantVipPayPop.vue?vue&type=template&id=422e49e0&"
import script from "./VantVipPayPop.vue?vue&type=script&lang=js&"
export * from "./VantVipPayPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports